module.exports = __webpack_public_path__ + "img/anti-wechat.d71f3b57.png";